import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  voidedFulfillmentSectionAriaLabel: {
    defaultMessage: 'Voided Shipment section',
    description: 'Aria label for a section showing voided shipments',
    id: 'CTYLyv',
  },
  multipleActiveFulfillmentsSectionAriaLabel: {
    defaultMessage: 'Multiple active labels section',
    description: 'Aria label for the section with a message informing the user that there are multiple active labels for the shipment',
    id: 'V6ynWE',
  },
  multipleActiveFulfillments: {
    defaultMessage: 'This shipment has multiple active labels. Please review and cancel any that are no longer valid.',
    description: 'message informing the user that there are multiple active fulfillments on the fulfillmentPlan',
    id: 'e/TaSk',
  },
});
